import React from 'react';
import PropTypes from 'prop-types';

import { VerticalRhythm } from 'mage-components';
import { SpacerVertical } from '@klarna/bubble-ui';

import { tPrefix } from '@/components/DocumentUpload/constants';

import { DocumentsHeader } from './DocumentsHeader';
import { DocumentsBlock } from './DocumentsBlock';

export const StakeholderDocuments = ({ isDesktop, t, stakeholdersWithDocuments = [] }) =>
  stakeholdersWithDocuments.map(
    (
      {
        id,
        data: { firstName, lastName } = {},
        roles = [],
        documentRequirements = [],
        documents = [],
      },
      index,
    ) => {
      const stakeholderId = `${id}`;

      if (documentRequirements.length === 0) {
        return null;
      }

      return (
        <React.Fragment key={stakeholderId}>
          {index > 0 && <VerticalRhythm spacing={{ mobile: 5, tablet: 5, desktop: 8 }} />}
          <DocumentsHeader
            isStakeholder
            title={`${firstName} ${lastName} ${t(`${tPrefix}.header_title`)}`}
          />
          <SpacerVertical spaceToken="space/150" />
          <DocumentsBlock
            isDesktop={isDesktop}
            stakeholderId={stakeholderId}
            stakeholderRoles={roles}
            documentRequirements={documentRequirements}
            uploadedDocuments={documents}
          />
        </React.Fragment>
      );
    },
  );

StakeholderDocuments.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  stakeholdersWithDocuments: PropTypes.array,
};
